import React, { ReactNode } from "react";
import { Typography } from "@mui/material";
import { Accordion, AccordionDetails, AccordionSummary } from "./styled";
import { AppSwitch } from "Components/Generic/AppSwitch";
import { InfoCircle } from "iconsax-react";

// Define the props for the ConfigSwitch component
type ConfigSwitchProps = {
  title: string;
  description?: string;
  path?: string;
  customDetails?: ReactNode;
  companyConfig: any;
  onConfigChange: (path: string, value: boolean) => void;
  hideSwitch?: boolean;
  disabled?: boolean;
};

export const ConfigSwitch: React.FC<ConfigSwitchProps> = ({
  title,
  description,
  path,
  customDetails,
  companyConfig,
  onConfigChange,
  hideSwitch = false,
  disabled = false,
}) => {
  if (!companyConfig) return null;

  // Function to extract value from path
  const getValueFromPath = (obj: any, path: string) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const value = hideSwitch ? true : path ? getValueFromPath(companyConfig, path) : false;

  // Determine if we should render the AccordionDetails section
  const shouldRenderDetails = hideSwitch || !!customDetails;

  return (
    <Accordion elevation={0} expanded={hideSwitch ? true : value}>
      <AccordionSummary expandIcon={false}>
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <div style={{ flex: 1 }}>
            <Typography variant="body1">{title}</Typography>
            {description && !customDetails && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px",
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                <InfoCircle size="16" style={{ marginRight: "6px" }} />
                <Typography variant="body2" style={{ fontSize: "12px", lineHeight: "1.2" }}>
                  {description}
                </Typography>
              </div>
            )}
          </div>
          {!hideSwitch && path && (
            <div style={{ marginLeft: "auto" }}>
              <AppSwitch
                checked={!!value}
                disabled={disabled}
                onChange={() => onConfigChange(path, !value)}
              />
            </div>
          )}
        </div>
      </AccordionSummary>
      {shouldRenderDetails && <AccordionDetails>{customDetails}</AccordionDetails>}{" "}
    </Accordion>
  );
};
